import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { useField } from 'formik'

export interface InputRadioProps {
  className?: string
  disabled?: boolean
  id: string
  label?: string
  name: string
  value?: string
}

export function InputRadio({ id, name, label, value, className = '' }: InputRadioProps) {
  const [{ checked, onChange, ...field }, { touched, error }, { setError }] = useField({ name, type: 'radio', value })
  const isError = touched && !!error

  function handleChange(e: React.ChangeEvent) {
    onChange(e)
    setError(undefined)
  }

  return (
    <StyledLabel
      className={`flex cursor-pointer items-center py-2 font-medium leading-100 md:py-3.5 ${className}`}
      htmlFor={id}
      isError={isError}
    >
      <Radio checked={checked} isError={isError}>
        <input className="hidden" id={id} onChange={handleChange} type="radio" {...field} />
      </Radio>

      {label}
    </StyledLabel>
  )
}

export const Radio = styled.div<{ checked?: boolean; isError: boolean }>`
  /* border-secondary bg-primary relative flex mr-4 w-6 h-6 border-2 rounded-full visible cursor-pointer */
  border-color: #e7e6e4;
  background-color: #ffffff;
  position: relative;
  display: flex;
  margin-right: 1rem;
  width: 1.5rem;
  height: 1.5rem;
  border-width: 2px;
  border-style: solid;
  border-radius: 9999px;
  visibility: visible;
  cursor: pointer;

  ${({ checked }) =>
    checked &&
    css`
      border-color: transparent;
      border-width: 1px;
      /* action-input = background: #000000 */
      background: #000000;

      &::after {
        content: '';
        background-color: #ffffff;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 9999px;
        transform: translate(-50%, -50%);
      }
    `}
`

export const StyledLabel = styled.label<{ checked?: boolean; isError: boolean }>`
  ${({ isError }) => isError && 'color: #C62D2C;'}

  > div {
    ${({ isError }) => isError && 'border-color: #EE533D; background-color: #FFE4DA;'}
  }
`
